import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsStudyKit = () => {
  return (
    <ComparisonPageTemplate
      platformName="StudyKit"
      platformUrl="https://studykit.app"
      seoDescription="Compare CSW and StudyKit AI study platforms. Discover why CSW offers better social learning and a larger community."
      seoKeywords="CSW vs StudyKit, StudyKit alternative, AI study app, free flashcard maker"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-studykit/"
      heroDescription="Looking for more than 10-minute AI sessions? CSW offers collaborative study and gamified learning with a vibrant community."
      alternativeDescription="While StudyKit provides AI-powered study sessions, CSW offers a complete learning ecosystem with collaboration."
      background="StudyKit is an AI-powered platform with personalized 10-minute study sessions, instant feedback, and automatic categorization."
      pros={[
        { text: "AI-powered personalized sessions" },
        { text: "Instant feedback" },
        { text: "Automatic topic categorization" }
      ]}
      cons={[
        { text: "Smaller user community" },
        { text: "Sessions may not suit in-depth study" },
        { text: "No social or gamified elements" }
      ]}
      cswFeatures={[
        { text: "Large Community", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Gamified Learning", available: true },
        { text: "Flexible Session Length", available: true }
      ]}
      competitorFeatures={[
        { text: "Large Community", available: false },
        { text: "Collaborative Study", available: false },
        { text: "Gamified Learning", available: false },
        { text: "Flexible Session Length", available: false }
      ]}
      benefits={[
        { icon: Brain, title: "Flexible Learning", description: "Study for as long as you need." },
        { icon: Users, title: "Vibrant Community", description: "Join millions of learners." },
        { icon: Clock, title: "Social & Gamified", description: "Stay motivated with gamification." }
      ]}
      forStudentsText="CSW offers flexible session lengths, a large community, and social learning features."
      pricingText="Both platforms offer free options, but CSW provides a more complete experience."
      competitorPrice="Free"
    />
  );
};

export default CSWvsStudyKit;
